export const USER_ROLES = {
  SUPER_ADMIN: "super_admin",
  SUPER_ADMIN_ALT: "superadmin", // backward compatibility
  ORG_ADMIN: "org_admin",
  USER: "user",
};

export const APPROVAL_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
};

export const UPGRADE_URL = "https://salesworx.ai/salesworx-contact";

export const DEFAULT_USER = {
  id: "",
  name: "",
  email: "",
  profileImage: null,
  isOnboarded: false,
  onboardingType: null,
  initials: "",
  role: USER_ROLES.USER,
  approvalStatus: null,
  hasAccessRequest: false,
  plan: null,
  organization_llm_type: null,
  trial_approved_at: null,
  trial_ends_at: null,
  /** After onboarding, user sees /pricing once; set true when continuing to join/demo flow */
  pricingPageCompleted: false,
  channels: {
    linkedin: null,
    whatsapp: null,
    outlook: null,
  },
};

export const STATUS_VARIANT_MAP = {
  Active: "success",
  Running: "success",
  Scheduled: "lightBlue",
  Paused: "warning",
  Draft: "neutral",
  Failed: "danger",
};

